export default "__VITE_ASSET__BpnAahYQ__"